var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "todoapp" }, [
    _c("header", { staticClass: "header" }, [
      _c("span", [
        _vm._v("[ " + _vm._s(_vm.todos[0] ? _vm.todos[0].date : "") + " ]")
      ]),
      _vm._v(" "),
      _c("input", {
        staticClass: "new-todo",
        attrs: {
          autocomplete: "off",
          placeholder: _vm.mode
            ? _vm.$t("dashboard.top10SmsCount")
            : _vm.$t("dashboard.top10Agent")
        },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.addTodo($event)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "main" }, [
      _c("input", {
        staticClass: "toggle-all",
        attrs: { id: "toggle-all", type: "checkbox" }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "toggle-all" } }),
      _vm._v(" "),
      _vm.todos.length
        ? _c(
            "ul",
            { staticClass: "todo-list" },
            _vm._l(_vm.todos, function(todo, index) {
              return _c("todo", { key: index, attrs: { todo: todo } })
            }),
            1
          )
        : _c("div", { staticClass: "no-data" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("common.noData")) + "\n    ")
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }